enum Languages {
  german = 'de',
  english = 'en',
}

export default Languages;
